import dayjs from 'dayjs';
import { isToday, timeAgo } from '/@/modules/core/app/helpers/DateHelper';
import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';
import { Estate } from '@/modules/estate/models/Estate';
import { Message } from '@/modules/messenger/_modules/message/models/Message';
import { EstateTask } from '/@/modules/estatetask/models/EstateTask';
import { ModelType } from '@/modules/core/app/constants/ModelType';
import { UserNotificationType } from '@/modules/notification/constants/UserNotificationType';
import { DateFormat } from '/@/modules/core/app/constants/date.constants';
import { UserNotificationMetaType } from '@/modules/notification/constants/UserNotificationMetaType';
import { NotificationTaskAssignedMeta } from '@/modules/notification/models/meta/NotificationTaskAssignedMeta';
import { NotificationMetaFactory } from '@/modules/notification/models/meta/NotificationMetaFactory';
import { NotificationTaskChangedStatusMeta } from '@/modules/notification/models/meta/NotificationTaskChangedStatusMeta';
import { NotificationEstateStatusUpdatedMeta } from '@/modules/notification/models/meta/NotificationEstateStatusUpdatedMeta';
import { User } from '@/modules/user/models/User';

export class Notification extends BaseEntityModel {
  id?: string;
  type?: UserNotificationType;
  estateId?: number;
  notifiableType?: ModelType;
  notifiableId?: number;
  modelType?: string;
  modelId?: number;
  metaType?: UserNotificationMetaType;
  meta?:
    | NotificationEstateStatusUpdatedMeta
    | NotificationTaskAssignedMeta
    | NotificationTaskChangedStatusMeta;
  createdByUserId?: number;
  readAt?: string;
  estate?: Relationship<Estate | null>;
  message?: Relationship<Message | null>;
  estateTask?: Relationship<EstateTask | null>;
  createdByUser?: Relationship<User | null>;

  constructor(model: Partial<Notification> = {}) {
    super(model);

    this.id = model.id;
    this.type = model.type;
    this.estateId = model.estateId;
    this.notifiableType = model.notifiableType;
    this.notifiableId = model.notifiableId;
    this.modelType = model.modelType;
    this.modelId = model.modelId;
    this.metaType = model.metaType;
    this.createdByUserId = model.createdByUserId;
    this.readAt = model.readAt;
    this.meta = model.meta ? NotificationMetaFactory.build(model.metaType, model.meta) : undefined;

    // @ts-ignore
    this.estate = Estate.mapModelOrNull(model.estate);
    // @ts-ignore
    this.message = Message.mapModelOrNull(model.message);
    // @ts-ignore
    this.estateTask = EstateTask.mapModelOrNull(model.estateTask);
    // @ts-ignore
    this.createdByUser = User.mapModelOrNull(model.createdByUser);
  }

  getModelName(): ModelType {
    return ModelType.NOTIFICATION;
  }

  get timeAgoUpdatedAt(): string {
    return timeAgo(this.updatedAt);
  }

  get isChatMessageUserNotification(): boolean {
    return this.type === UserNotificationType.CHAT_MESSAGE_USER_NOTIFICATION;
  }

  get isCommentMessageUserNotification(): boolean {
    return this.type === UserNotificationType.COMMENT_MESSAGE_USER_NOTIFICATION;
  }

  get isEstateStatusUpdatedUserNotification(): boolean {
    return this.type === UserNotificationType.ESTATE_STATUS_UPDATED_USER_NOTIFICATION;
  }

  get isUserEstateTaskAssignedUserNotification(): boolean {
    return this.type === UserNotificationType.USER_ESTATE_TASK_ASSIGNED_USER_NOTIFICATION;
  }

  get isUserEstateTaskChangedStatusNotification(): boolean {
    return this.type === UserNotificationType.USER_ESTATE_TASK_CHANGED_STATUS_NOTIFICATION;
  }

  get isReplyByEmailOnInactiveConversationUserNotification(): boolean {
    return (
      this.type === UserNotificationType.REPLY_BY_EMAIL_ON_INACTIVE_CONVERSATION_USER_NOTIFICATION
    );
  }

  get displayCreatedAt(): string {
    return isToday(this.createdAt)
      ? this.timeAgoCreatedAt
      : dayjs(this.createdAt).format(DateFormat.MONTH_DAY_WITH_ORDINAL_TWELVE_HOUR);
  }
}
